export const transportType = {
  SEA: "SEA",
  RAIL: "RAIL",
  AIR: "AIR",
  ROAD: "ROAD",
};
